import { useEffect, useState } from "react"
import { Button } from "react-aria-components"
import IconChevronRight from "../../../../../assets/icons/icon-chevron-right.svg"
import { httpGet } from "../../../../../modules/Backend"
import * as Navigation from "../../../../../modules/Navigation";
import { useLocation, useNavigate } from "react-router-dom";

interface ISidePanelInfoSmall {
    title: string,
    value: string,
    entityName: string,
    entityId: string
}

export default function SidePanelNavLink({ title, value, entityName, entityId }: ISidePanelInfoSmall) {
    const [data, setData] = useState<any>()
    const navigate = useNavigate()

    const { pathname } = useLocation()
    const show = !pathname.includes(entityName)

    function view() {
        Navigation.view.navigate(navigate, entityName, entityId, data)
    }

    async function GetData() {
        var result = await httpGet(`api/${entityName}/get?id=${entityId}`)

        if (result.data) {
            setData(result.data)
        }
    }

    useEffect(() => {
        GetData()
    }, [])

    return (<>
        {show &&
            <div className="side-panel__info-box margin__top--s">
                <p className="small">{title}</p>
                <div className="display--flex justifyContent--space-between">
                    {data && <>
                        <div className="side-panel__blue-background side-panel__breadcrumb-wrapper width--fitContent">
                            <p className="breadcrumb">{value}</p>
                        </div>
                        <Button className={"button button--text-only button--with-icon alignSelf--start"} onPress={() => view()}>
                            <p className="side-panel__button-text">View</p>
                            <div><img src={IconChevronRight} /></div>
                        </Button>
                    </>
                    }
                </div>
            </div>
        }
    </>
    )
}